const Arsa = resolve => {
    require.ensure(['../views/apps/arsa/Arsa'], () => {
        resolve(require('../views/apps/arsa/Arsa'))
    })
};
const ArsaTanimla = resolve => {
    require.ensure(['../views/apps/arsa/ArsaTanimla'], () => {
        resolve(require('../views/apps/arsa/ArsaTanimla'))
    })
};
const ArsaListesi = resolve => {
    require.ensure(['../views/apps/arsa/ArsaListesi'], () => {
        resolve(require('../views/apps/arsa/ArsaListesi'))
    })
};
const ArsaGuncelle = resolve => {
    require.ensure(['../views/apps/arsa/ArsaGuncelle'], () => {
        resolve(require('../views/apps/arsa/ArsaGuncelle'))
    })
};


import layouts from '../layout'
import Vue from 'vue'
Vue.component('arsatahsis-tanimla', ArsaTanimla);
Vue.component('arsatahsis-listesi', ArsaListesi);
Vue.component('arsatahsis-guncelle', ArsaGuncelle);


export default {
    path: '/arsa',
    name: 'arsa',
    component: Arsa,
    meta: {
        layout: layouts.navLeft
    }

}